import { html, render } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { prop } from "$json/lib/functional";
import { _ } from "$json/lib/gettext";

(function ($) {
  const id = `p-step-x-of-n`;

  const translations = {
    [`${id}--step`]: {
      en: "Step",
      nl: "Stap",
      fr: "Étape",
      de: "Schritt",
      es: "Passo",
      pt: "Paso",
      uk: "крок",
      ru: "Шаг"
    },
    [`${id}--of`]: {
      en: "of",
      nl: "van",
      fr: "sur",
      de: "von",
      es: "de",
      pt: "de",
      uk: "з",
      ru: "из"
    }
  };

  _.addTranslations(translations);

  $(document).on("bb:postHandleData", function (event, data) {
    if (data && data.jumplist) {
      // @todo: currently jumplist always has a selected item.
      // Just do not know when this happened exactly. So leave the
      // first statement in for now.
      //
      // First set .past:last
      // to .selected if no .selected.
      //        data.jumplist = [];
      const jumplist = data.jumplist.filter(prop("ischapter"));
      const total = jumplist.length;
      for (let i = total - 1; i >= 0; i--) {
        if (["selected", "past"].includes(jumplist[i].status)) {
          for (let wrapper of document.querySelectorAll(`.${id}`)) {
            render(
              html`<span class="${id}--step">${_(`${id}--step`)}&nbsp;</span
                ><span class="${id}--current">${i + 1}</span
                ><span class="${id}--of">&nbsp;${_(`${id}--of`)}&nbsp;</span
                ><span
                  class=${classMap({
                    [`${id}--total`]: true,
                    [`${id}--last`]: total === i + 1
                  })}
                  >${total}</span
                >`,
              wrapper
            );
          }
          break;
        }
      }
    }
  });
})(jQuery);
